import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const AuthHeader = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-sm border-b border-border">
      <div className="flex items-center justify-between h-16 px-6 max-w-7xl mx-auto">
        {/* Logo */}
        <Link to="/event-discovery" className="flex items-center space-x-2">
          <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
            <Icon name="Calendar" size={20} color="white" />
          </div>
          <span className="text-xl font-semibold text-foreground">EventGrid</span>
        </Link>

        {/* Navigation Links */}
        <nav className="hidden md:flex items-center space-x-6">
          <Link
            to="/event-discovery"
            className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
          >
            Discover Events
          </Link>
          <Link
            to="/host-dashboard"
            className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
          >
            For Hosts
          </Link>
          <div className="text-sm font-medium text-muted-foreground">
            Help
          </div>
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <Icon name="Menu" size={20} className="text-muted-foreground" />
        </div>
      </div>
    </header>
  );
};

export default AuthHeader;